import { createRouter, createWebHistory } from 'vue-router'


//Import Company Routes 
import adminUserRoute from './adminUserRoute.js'
import companyUserRoute from './companyUsersRoute.js'

//Merge all the route
const finalRoute = adminUserRoute.concat(companyUserRoute);

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: finalRoute,
    linkActiveClass: 'active',
    linkExactActiveClass: "active"
})

router.beforeEach((to, from, next) => {
    var mainTitle = localStorage.getItem('companyName');
    if (mainTitle == null || mainTitle == '')
        mainTitle = 'Welcome';
    if (to.name == 'undefinded' || typeof to.name == "undefined") {
        to.name = 'login'

    }
    document.title = `${mainTitle} | ` + `${to.name}`;
    window.scrollTo(0, 0);
    next();
})

export default router
